import { apiClient } from './api/client';

export interface AccessLog {
  id: number;
  user_id: number | null;
  user_email: string;
  user_name: string | null;
  ip_address: string | null;
  user_agent: string | null;
  login_method: string;
  status: 'success' | 'failure';
  failure_reason: string | null;
  created_at: string;
}

export interface AccessLogListResponse {
  data: AccessLog[];
  total: number;
}

export interface AccessLogFilters {
  page?: number;
  limit?: number;
  status?: string;
  email?: string;
}

export const accessLogService = {
  async getAll(filters: AccessLogFilters = {}): Promise<AccessLogListResponse> {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.status) params.set('status', filters.status);
    if (filters.email) params.set('email', filters.email);

    const response = await apiClient.get<AccessLogListResponse>(
      `/access-logs?${params.toString()}`,
    );
    return response.data;
  },
};
